import styled from "styled-components";
import { Colors } from "../../../assets/styles/StyleTypes";

type DivSelectProps = {
  isLogin: boolean;
};

export const DivSelectLangStyle = styled.div<DivSelectProps>`
  position: relative;
  z-index: 9;
  width: 70%;
  max-width: 300px;

  & .selected {
    width: 100%;
    color: ${(props) =>
      props.isLogin ? Colors.PRIMARY_HIGHLIGHT : props.theme.colors.textHeader};
    font-weight: 700;
    font-size: 16px;
    border-radius: 2px;
    cursor: pointer;
    display: flex;
    justify-content: right;
    align-items: center;
    margin: 0;

    .language {
      margin: 0px 5px;
    }
    .down-arrow {
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid
        ${(props) =>
          props.isLogin
            ? Colors.PRIMARY_HIGHLIGHT
            : props.theme.colors.textHeader};
      color: ${(props) =>
        props.isLogin
          ? Colors.PRIMARY_HIGHLIGHT
          : props.theme.colors.textHeader};
    }

    .up-arrow {
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 5px solid
        ${(props) =>
          props.isLogin
            ? Colors.PRIMARY_HIGHLIGHT
            : props.theme.colors.textHeader};
      color: ${(props) =>
        props.isLogin
          ? Colors.PRIMARY_HIGHLIGHT
          : props.theme.colors.textHeader};
    }
  }

  & .dropdown {
    background-color: ${(props) =>
      props.isLogin
        ? Colors.HIGH_MEDIUM
        : props.theme.colors.dropdownBackground};
    margin: 0;
    padding: 0;
    position: absolute;
    right: 0;
    width: 100%;
    border-radius: 5px;
    box-shadow: ${(props) => props.theme.shadows.modalShadow};

    li {
      color: ${(props) =>
        props.isLogin ? Colors.LOW_PURE : props.theme.colors.textPrimary};
      list-style-type: none;
      width: 100%;
      text-align: right;
      font-size: 12px;
      padding: 5px 15px;
      cursor: pointer;
      font-family: Roboto, sans-serif;
      font-weight: normal;

      :hover {
        background-color: ${(props) =>
          props.isLogin ? Colors.HIGH_DARK : props.theme.colors.dropdownHover};
      }
    }
  }

  @media (max-width: 960px) {
    width: fit-content;

    span {
      color: ${Colors.HIGH_PURE};
    }

    & .selected {
      width: auto;
      .up-arrow {
        border-bottom: 5px solid ${Colors.HIGH_PURE};
      }
      .down-arrow {
        border-top: 5px solid ${Colors.HIGH_PURE};
      }
    }
  }
`;

export const LanguageOptions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  width: 100%;
  min-height: 0;
  flex: 1 1 auto;
  color: ${(props) => props.theme.colors.textPrimary};

  .ppsa-content-options-container {
    width: 100%;
    min-height: 0;
    flex: 1 1 auto;
    overflow-y: auto;
    overscroll-behavior: contain;
  }

  .ppsa-content-option {
    display: flex;
    min-height: 48px;
    align-items: center;
    padding-inline: 5px;
    width: 100%;
  }

  .ppsa-content-item-option {
    display: flex;
    width: 100%;
    min-width: 0;
    align-items: center;
    gap: 10px;
    cursor: pointer;
  }

  .ppsa-option {
    min-width: 0;
    flex: 1;
    font-size: 12px;
    font-weight: 400;
  }
`;
